export default __webpack_public_path__ + "static/media/miitoken_logo.e73dbf21.png";